
//import { useSelect  } from '@wordpress/data';
import { useEffect } from '@wordpress/element';
import { useSelect } from '@wordpress/data';
import { SlideButton } from './slide-button';
import {widthStyle, size,flex,position,background,VayuBlocksTypography, boxShadow, dimensions, borderRadiusStyle, borderStyle,VayuBlocksCssJustify,VayuBlocksCssTextAlign, VayuBlocksCssborderFrame,borderWidthStyle,VayuBlocksInfiniteAnimation,getResponsiveRangeValue } from './style';

 const VayuBlocksUniqueId = (props) => {
        const {setAttributes,clientId} =props

        useEffect(() => {
           // const isSaving = useSelect((select) => select('core/editor').isSavingPost());
            // Ensure the uniqueId is set if it's not
                setAttributes({ uniqueId: `vayu-blocks-${clientId.substring(0, 8)}` });
        }, []);
}

const VayuBlocksCssDimensions = (dim,getView) => {
    const value = dim?.[getView];

    if (!value || Object.keys(value).length === 0) {
     // If object is empty, return default padding
     return '0 0 0 0';
 }
 const top = value.top !== undefined? `${value.top}` : '0';
 const right = value.right !== undefined? `${value.right}` : '0';
 const bottom = value.bottom !== undefined ? `${value.bottom}` : '0';  // Set to '0px' if undefined
 const left = value.left !== undefined ? `${value.left}` : '0';        // Set to '0px' if undefined
 return `${top} ${right} ${bottom} ${left}`;
};

const VayuBlocksBlockEditor =()=>{
    return useSelect(
        (select) => select('core/block-editor').getSettings(),
        []
    );
}

export {
    VayuBlocksUniqueId,
    VayuBlocksCssDimensions,
    VayuBlocksBlockEditor,
    VayuBlocksCssJustify,
    VayuBlocksCssborderFrame,
    VayuBlocksInfiniteAnimation,
    VayuBlocksTypography,
    borderWidthStyle,
    VayuBlocksCssTextAlign,
    borderStyle,
    borderRadiusStyle,
    boxShadow,
    dimensions,
    SlideButton,
    background,
    position,
    flex,
    size,
    getResponsiveRangeValue,
    widthStyle,
};
